import { LOCAL_STORAGE_NAMES } from '../constants/constants';
import { ThemeColorKey, themeColors } from '../components/config/variables';
import { readUserPreference, storeUserPreference } from './userPreferences';

export const THEME_COLORS = Object.keys(themeColors) as ThemeColorKey[];

export const DEFAULT_THEME_COLOR: ThemeColorKey = 'primary';

export const THEME_COLOR_LABEL_KEYS: Record<ThemeColorKey, string> = {
  primary: 'common:themeColor.primary',
  emeraldGreen: 'common:themeColor.emeraldGreen',
  pink: 'common:themeColor.pink',
  blue: 'common:themeColor.blue',
  darkBlue: 'common:themeColor.darkBlue',
  purple: 'common:themeColor.purple',
  limeGreen: 'common:themeColor.limeGreen',
};

export const isThemeColor = (value: unknown): value is ThemeColorKey =>
  THEME_COLORS.includes(value as ThemeColorKey);

export const readStoredThemeColor = (userId?: string): ThemeColorKey =>
  readUserPreference(LOCAL_STORAGE_NAMES.themeColor, userId, isThemeColor, DEFAULT_THEME_COLOR);

export const storeThemeColor = (userId: string, color: ThemeColorKey): void =>
  storeUserPreference(LOCAL_STORAGE_NAMES.themeColor, userId, color);

export const applyThemeColor = (color: ThemeColorKey): void => {
  document.documentElement.dataset.themeColor = color;
};
